
import { useState, useEffect } from 'react';
import { Review } from '@/lib/types';

// Job categories for filtering
export const JOB_CATEGORIES = [
  "Overall",
  "Sales",
  "Marketing",
  "Engineering",
  "Support",
  "HR",
  "Finance"
];

export const useJobCategoryFilter = (allReviews: Review[]) => {
  const [selectedCategory, setSelectedCategory] = useState<string>("Overall");
  
  // Filter reviews by selected category
  const filteredReviews = selectedCategory === "Overall" 
    ? allReviews
    : allReviews.filter(review => review.jobCategory === selectedCategory);
    
  // Reset the page when category changes
  useEffect(() => {
    // This is just a placeholder for the effect dependency
    // The actual page reset happens in the parent component
  }, [selectedCategory]);
  
  return {
    selectedCategory,
    setSelectedCategory,
    filteredReviews,
    JOB_CATEGORIES
  };
};
